<div class="text-center my-4">
    <img src="/assets/icons/something-went-wrong-icon.svg" height="60" class="my-3">

    <h5>{{ 'si_pts_chrome_not_logged_in_header' | cmsText | async }}</h5>

    <p [appParagraph]="3">{{ 'si_pts_chrome_not_logged_in_text' | cmsText | async }}</p>

    <a [routerLink]="'/'" appStandardButton>{{ 'si_pts_chrome_not_logged_in_back' | cmsText | async }}</a>

</div>
